import { __assign, __extends } from "tslib";
/* ******************** LEAVE AT TOP LEVEL ******************** */
import './Core/CriticalImports';
/* ************************************************************ */
import { registerLocale } from 'i18n-iso-countries';
import countries_de from "i18n-iso-countries/langs/de.json";
import countries_en from "i18n-iso-countries/langs/en.json";
import countries_fr from "i18n-iso-countries/langs/fr.json";
import countries_it from "i18n-iso-countries/langs/it.json";
import * as React from 'react';
import initReactFastclick from 'react-fastclick';
import { IntlProvider } from 'react-intl';
import Builder from './App/Builder';
import { LoadingBarControl } from './App/LoadingBarControl';
import { NewContent } from './App/NewContent';
import { LoadingSpinner } from './Controllers/Shared/LoadingSpinner';
import Offline from './Controllers/Shared/Offline';
import Core from './Core';
import AppHistory from './Core/AppHistory';
import Culture from './Core/Culture';
import UserManager from './Core/UserManager';
import messages_de from "./Translations/de.json";
import messages_en from "./Translations/en.json";
import messages_fr from "./Translations/fr.json";
import messages_it from "./Translations/it.json";
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    /**
     * Class constructor
     * @param props
     */
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.displayName = App.name;
        /**Intl messages */
        _this.Messages = null;
        _this.state = {
            initialized: false,
            online: false
        };
        return _this;
    }
    /**Start build core application */
    App.prototype.Build = function () {
        var _this = this;
        Core.Init(this.props)
            .then(function (res) {
            if (res === 1) {
                _this.SetCultureMessages();
                _this.setState({
                    initialized: true,
                    online: AppHistory.Online
                });
            }
            else if (res === -1) {
                UserManager.SignOutRedirect();
            }
            else {
                console.error("[App - 1] - Critical error!");
                console.error(res);
            }
        }).catch(function (err) {
            console.error("[App - 2] - Critical error!");
            console.error(err);
        });
        initReactFastclick();
    };
    /**Handle component mount event */
    App.prototype.componentDidMount = function () {
        this.Build();
    };
    /**Set culture messages for the culture in use */
    App.prototype.SetCultureMessages = function () {
        switch (Culture.Get()) {
            case 'fr':
                document.title = this.props.AppTitle.French;
                registerLocale(countries_fr);
                this.Messages = this.props.Messages === undefined ? messages_fr : __assign(__assign({}, messages_fr), this.props.Messages.Fr);
                break;
            case 'it':
                document.title = this.props.AppTitle.Italian;
                registerLocale(countries_it);
                this.Messages = this.props.Messages === undefined ? messages_it : __assign(__assign({}, messages_it), this.props.Messages.It);
                break;
            case 'en':
                document.title = this.props.AppTitle.English;
                registerLocale(countries_en);
                this.Messages = this.props.Messages === undefined ? messages_en : __assign(__assign({}, messages_en), this.props.Messages.En);
                break;
            default:
                document.title = this.props.AppTitle.German;
                registerLocale(countries_de);
                this.Messages = this.props.Messages === undefined ? messages_de : __assign(__assign({}, messages_de), this.props.Messages.De);
                break;
        }
    };
    /**
     * Render component
     * @returns {JSX.Element} Component layout
     * */
    App.prototype.render = function () {
        return (!this.state.initialized ?
            React.createElement("div", { id: "loading-content" },
                React.createElement("div", { className: "loading-content-row" },
                    React.createElement("div", { className: "loading-content-column" },
                        React.createElement(LoadingSpinner, null))))
            :
                this.state.online ?
                    React.createElement(React.Fragment, null,
                        React.createElement(LoadingBarControl, null),
                        React.createElement(IntlProvider, { locale: Culture.Get(), messages: this.Messages },
                            React.createElement(React.Fragment, null,
                                React.createElement(NewContent, null),
                                React.createElement(Builder, __assign({}, this.props), this.props.children))))
                    :
                        React.createElement(IntlProvider, { locale: Culture.Get(), messages: this.Messages },
                            React.createElement(Offline, __assign({}, { OnInit: true }))));
    };
    return App;
}(React.Component));
export { App };
//# sourceMappingURL=App.js.map